<script>
import KeywordBlock from "@/driver/pages/orders/accepts/collection/blocks/_Keyword.vue";
import OrderTransportBlock from "@/driver/pages/orders/accepts/collection/blocks/_Transport.vue";
import OrderEmissionBlock from "@/driver/pages/orders/accepts/collection/blocks/_Emission.vue";
import OrderCollectBlock from "@/driver/pages/orders/accepts/collection/blocks/_Collect.vue";
import OrderSalesItemBlock from "@/driver/pages/orders/accepts/collection/blocks/_SalesItem.vue";
import RevisionHistoryDialog from "@/driver/pages/orders/accepts/collection/dialogs/_RevisionHistoryDialog.vue";
import SendMailApprovalDialog from '@/driver/pages/orders/accepts/collection/dialogs/_SendMailApprovalDialog.vue'
import MemoBlock from "@/driver/pages/orders/accepts/collection/blocks/_Memo.vue";
import DriverInstructionBlock from "@/driver/pages/orders/accepts/collection/blocks/_DriverInstruction.vue";
import {mapActions, mapState} from "vuex";

export default {
  name: 'AcceptCollectionDetail',
  components: {
    RevisionHistoryDialog,
    SendMailApprovalDialog,
    DriverInstructionBlock,
    OrderCollectBlock,
    OrderEmissionBlock,
    OrderSalesItemBlock,
    OrderTransportBlock,
    KeywordBlock,
    MemoBlock,
  },
  mixins: [],
  props: {
    orderType: {
      type: String,
      default: 'collection'
    },
    orderId: {
      type: [String, Number],
      default: () => null
    },
    callerType: {
      type: String,
      default: () => 'order'
    },
  },
  data() {
    return {
      showUpdateHistoryDialog: false,
      enableMailApprovalDialog: false,
      order: null,
      targetOrderId: null,
      canShowEditButton: false,
      deliverers: [],
      registers: [],

      packings: [],
      quantityUnits: [],
      quantityConfirms: [],
      hazardousSubstances: [],
      items: [],

      transportations: [],

      disposalMethods: [],

    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
      /* 配車の利用 */
      usesAllocate: 'use_allocate'
    }),
  },
  watch: {
    order (newValue) {
      const statuses = ['collection_accepted', 'collection_allocated', 'collection_reserved', 'collection_transported']
      if (newValue) {
        this.canShowEditButton = statuses.includes(newValue.status)
      } else {
        this.canShowEditButton = false
      }
    },
  },
  created() {
    console.log('AcceptCollectionDetail#created')
    this.refreshDetail()
  },
  methods: {
    ...mapActions('DriverOrderAcceptCollection', {
      fetchOrder: 'show',
    }),
    ...mapActions('DriverMasterSearchEmissionDeliverer', {
      fetchDeliverers: 'index',
    }),
    ...mapActions('DriverMasterSearchEmissionRegister', {
      fetchRegisters: 'index'
    }),
    ...mapActions('DriverMasterSearchPacking', {
      fetchPackings: 'index',
    }),
    ...mapActions('DriverMasterSearchQuantityUnit', {
      fetchQuantityUnits: 'index',
    }),
    ...mapActions('DriverMasterSearchQuantityConfirm', {
      fetchQuantityConfirms: 'index',
    }),
    ...mapActions('DriverMasterSearchHazardousSubstance', {
      fetchHazardousSubstances: 'index',
    }),
    ...mapActions('DriverMasterSearchItem', {
      fetchItems: 'index',
    }),
    ...mapActions('DriverMasterSearchTransportation', {
      fetchTransportations: 'index',
    }),
    ...mapActions('DriverMasterSearchDisposalMethod', {
      fetchDisposalMethods: 'index',
    }),
    /**
     * ダイアログ上での登録処理完了後のコールバック処理
     * ダイアログを閉じ、再取得を行う.
     */
    sendMailRegisterCallBack () {
      this.closeDialogCallback()
      this.backButtonClickEvent()
    },
    closeUpdateHistoryModal () {
      this.showUpdateHistoryDialog = false
    },
    showUpdateHistoriesButtonClickEvent () {
      this.showUpdateHistoryDialog = true
    },
    enableMailApprovalDialogButtonClickEvent (order) {
      this.targetOrderId = order.id
      this.enableMailApprovalDialog = true
    },
    closeDialogCallback () {
      this.enableMailApprovalDialog = false
    },
    dialogRegisterCallback () {
      this.$emit('refreshCallback')
      this.refreshDetail();
    },
    /**
     * 再取得
     */
    refreshDetail () {
      if (this.order) {
        this.order = null
      }
      this.deliverers = []
      this.registers = []

      this.fetchOrder({ id: this.orderId }).then((content) => {
        this.order = content
        const emissionLocationId = this.order.use_spot_emission_location ? null : this.order.emission_location.id
        if (this.order.emission.id) {
          this.fetchDeliverers({ id: this.order.emission.id, emission_location_id: emissionLocationId }).then((content) => {
            this.deliverers = content.deliverers
          })
          this.fetchRegisters({ id: this.order.emission.id, emission_location_id: emissionLocationId }).then((content) => {
            this.registers = content.registers
          })
        }
      })


      this.fetchPackings().then((content) => {
        this.packings = content.packings
      })
      this.fetchQuantityUnits().then((content) => {
        this.quantityUnits = content.quantity_units
      })
      this.fetchQuantityConfirms().then((content) => {
        this.quantityConfirms = content.quantity_confirms
      })
      this.fetchHazardousSubstances().then((content) => {
        this.hazardousSubstances = content.hazardous_substances
      })
      this.fetchItems().then((content) => {
        this.items = content.items
      })
      this.fetchTransportations().then((content) => {
        this.transportations = content.transportations
      })
      this.fetchDisposalMethods().then((content) => {
        this.disposalMethods = content.disposal_methods
      })
    },
    /**
     * 戻るボタン クリックイベント
     */
    backButtonClickEvent () {
      if (this.$route.query.d !== undefined) {
        this.$router.push( { name: 'DriverDashboard' } )
      } else {
        this.$router.push( { name: 'DriverOrderAccepts' } )
      }
    },
  }
}
</script>

<template>
  <div v-if="order">
    <v-row :class="{ 'mt-2': callerType === 'modal' }">
      <v-col cols="12">
        <v-chip
          x-small
          label
          dark
          :color="order.status | status_chip_order_color(order.order_type)"
        >
          {{ order.status | status_to_label_accept(order.order_type, usesAllocate) }}
        </v-chip>
        &nbsp;
        <strong>{{ order.emission.name }}</strong>
        <template v-if="order.photos && order.photos.length > 0">
          <v-icon small color="primary" class="ml-2" style="vertical-align: middle;">mdi-camera</v-icon>
          <span class="ml-1" style="vertical-align: middle;">{{ order.photos.length }}枚</span>
        </template>
      </v-col>
    </v-row>

    <!-- 否決理由 -->
    <v-row v-if="order.status && order.rejection_reason">
      <v-col>
        <v-alert
          prominent
          type="error"
        >
          <v-row align="center">
            <v-col class="grow">
              {{ order.rejection_reason }}
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>
    <!-- /否決理由 -->

    <v-row class="d-flex mb-6">
      <v-col cols="12" md="11" class="pl-0 pr-0">
        <div class="header-box">
          <!-- 受注番号 -->
          <div class="item">
            <h5>
              受注番号
            </h5>
            <div class="text-right pr-1">
              <small>{{ order.order_no }}</small>
            </div>
          </div>
          <!-- /受注番号 -->
          <!-- 受注日 -->
          <div class="item">
            <h5>受注日</h5>
            <div class="text-center">
              <small>
                {{ order.order_date | date_format }}
              </small>

            </div>
          </div>
          <!-- /受注日 -->
          <!-- 依頼番号 -->
          <div class="item">
            <h5>依頼番号</h5>
            <div class="text-right">
              <small>
                {{ order.request_no }}
              </small>
            </div>
          </div>
          <!-- /依頼番号 -->
          <!-- 依頼日 -->
          <div class="item">
            <h5>依頼日</h5>
            <div class="text-center">
              <small>
                {{ order.request_date | date_format }}
              </small>
            </div>
          </div>
          <!-- /依頼日 -->
          <!-- 回収廃棄物 -->
          <div class="item" style="width: 10%;">
            <h5>回収廃棄物</h5>
            <div class="text-left pl-1">
              <small>
                {{ order.item_name }}<br />
                <span v-if="order.total_items_count > 0" style="display: inline-block;">全&nbsp;{{ order.total_items_count }}件</span>
              </small>
            </div>
          </div>
          <!-- /回収廃棄物 -->
          <!-- 回収日 -->
          <div class="item" style="width: 12%;">
            <h5>回収日</h5>
            <div class="text-center">
              <small>
                {{ order.collected_date | date_format }}&nbsp;
                <br />{{ order.preferred_start_time | from_to_linked_time(order.preferred_end_time, ' 〜 ') }}
              </small>
            </div>
          </div>
          <!-- /回収日 -->
          <!-- マニフェスト区分 -->
          <div class="item" style="width: 11%;">
            <h5>マニフェスト区分</h5>
            <div class="pl-1">
              <small>
                {{ order.manifest_type | manifest_type_to_label }}
              </small>
            </div>
          </div>
          <!-- /マニフェスト区分 -->
          <!-- 排出者メール承認 -->
          <div v-if="order.manifest_type === 'dxe_form'" class="item" style="width: 11%;">
            <h5>排出者メール承認</h5>
            <div class="pl-1">
              <small>
                {{ order.emission_approval_flg ? '利用する' : '利用しない' }}
              </small>
            </div>
          </div>
          <!-- /排出者メール承認 -->
          <!-- 営業担当者 -->
          <div class="item">
            <h5>営業担当者</h5>
            <div class="pl-1">
              <small>
                {{ order.sales_staff || '-' }}
              </small>
            </div>
          </div>
          <!-- /営業担当者 -->
          <!-- DXE起票担当者 -->
          <div class="item" style="width: 9%">
            <h5>DXE起票担当者</h5>
            <div class="pl-1">
              <small>
                {{ order.dxe_vote_staff || '-' }}
              </small>
            </div>
          </div>
          <!-- /DXE起票担当者 -->
          <!-- 過去マニフェストの起票, 売上計上しない -->
          <div class="item" style="width: 18%;">
            <v-checkbox
              v-model="order.past_manifest"
              dense
              disabled
              hide-details="auto"
            >
              <template v-slot:label>
                <small>過去マニフェストの起票</small>
              </template>
            </v-checkbox>
            <v-checkbox
              v-if="isBilling"
              v-model="order.not_recorded_sales"
              dense
              disabled
              hide-details="auto"
            >
              <template v-slot:label>
                <small>売上計上しない</small>
              </template>
            </v-checkbox>
          </div>
          <!-- /過去マニフェストの起票, 売上計上しない -->
        </div>
      </v-col>
      <v-col cols="12" md="1">
        <v-btn
          rounded
          color="white"
          @click="showUpdateHistoriesButtonClickEvent"
        >
          更新履歴&emsp;&gt;
        </v-btn>
      </v-col>

    </v-row>
    <!-- 配車詳細 -->
    <v-row
      v-if="usesAllocate && $props.orderType !== 'self_emission'"
    >
      <v-col>
        <h4>配車詳細</h4>
        <v-card flat class="rounded-card">
          <v-card-text
            v-if="order.driver"
          >
            <v-list>
              <v-list-item>
                <v-list-item-avatar
                  color="primary"
                  size="48"
                >
                  <v-img
                    v-if="order.driver.image_url"
                    :alt="`${order.driver.name} avatar`"
                    :src="order.driver.image_url"
                  />
                  <span v-else class="primary white--text" style="font-size: 80%">
                    {{ order.driver.name.slice(0, 2) }}
                  </span>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-left">
                    <h3>{{ order.driver.name }}</h3>
                  </v-list-item-title>
                  <v-list-item-title
                    v-if="order.driver.vehicle_number"
                    class="text-left"
                  >
                    {{ order.driver.vehicle_number }}&nbsp;
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-text
            v-else
          >
            <h3>登録なし</h3>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- /配車詳細 -->

    <v-row>
      <v-col class="pb-0">
        <h4>回収詳細</h4>
        <v-card flat class="rounded-card">
          <!-- 回収日 -->
          <order-collect-block
            :can-show-edit-button="canShowEditButton"
            :order="order"
            @refreshDetail="dialogRegisterCallback"
          />
          <!-- /回収日 -->

          <!-- 排出事業者情報 -->
          <order-emission-block
            :can-show-edit-button="canShowEditButton"
            :order="order"
            :deliverers="deliverers"
            :registers="registers"
            @refreshDetail="dialogRegisterCallback"
          />
          <!-- /排出事業者情報 -->

          <!-- ドライバー指示メモ -->
          <driver-instruction-block
            v-if="$props.orderType !== 'self_emission'"
            :can-show-edit-button="canShowEditButton"
            :order="order"
            @refreshDetail="dialogRegisterCallback"
          />
          <!-- /ドライバー指示メモ -->

          <!-- 検索キーワード -->
          <keyword-block :order="order" />
          <!-- 検索キーワード -->

          <!-- 運搬情報 -->
          <order-transport-block
            :can-show-edit-button="canShowEditButton"
            :order="order"
            :transportations="transportations"
            :deliverers="deliverers"
            :registers="registers"
            @refreshDetail="dialogRegisterCallback"
          />
          <!-- /運搬情報 -->

          <!-- 連絡事項 -->
          <memo-block :collection-request="order" />
          <!-- 連絡事項 -->

          <!-- 廃棄物情報 -->
          <order-sales-item-block
            :can-show-edit-button="canShowEditButton"
            :order="order"
            :packings="packings"
            :quantity-units="quantityUnits"
            :quantity-confirms="quantityConfirms"
            :hazardous-substances="hazardousSubstances"
            :items="items"
            :transportations="transportations"
            :disposal-methods="disposalMethods"
            :is-billing="isBilling"
            :order-type="$props.orderType"
            @refreshDetail="dialogRegisterCallback"
          />
          <!-- /廃棄物情報 -->

          <v-card-actions
            v-if="callerType !== 'modal'"
          >
            <v-spacer />
            <v-btn
              v-if="order.remand_manifest || order.await_approval_manifest"
              color="primary"
              class="mr-3"
              @click="enableMailApprovalDialogButtonClickEvent(order)"
            >
              排出再申請
            </v-btn>
            <v-btn
              @click="backButtonClickEvent"
            >
              戻る
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <revision-history-dialog
      :order="order"
      :enable-dialog="showUpdateHistoryDialog"
      @closeUpdateHistoryModal="closeUpdateHistoryModal"
    />
    <send-mail-approval-dialog
      :enable-dialog="enableMailApprovalDialog"
      :order-id="targetOrderId"
      @closeCallback="closeDialogCallback"
      @registerCallback="sendMailRegisterCallBack"
    />
  </div>
</template>

<style scoped lang="scss">

.header-box {
  display: flex;
  flex-wrap: wrap;
  & div.item {
    width: 8%;
    & h5 {
      padding: 5px 0;
      text-align: center;
    }
    & div {
      text-align: center !important;
    }
  }
}
</style>
